// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['ca_ES']  = {
  "name": "ca_ES",
  "day": {
    "abbrev": [
      "dg",
      "dl",
      "dt",
      "dc",
      "dj",
      "dv",
      "ds"
    ],
    "full": [
      "diumenge",
      "dilluns",
      "dimarts",
      "dimecres",
      "dijous",
      "divendres",
      "dissabte"
    ]
  },
  "month": {
    "abbrev": [
      "gen",
      "feb",
      "mar",
      "abr",
      "mai",
      "jun",
      "jul",
      "ago",
      "set",
      "oct",
      "nov",
      "des"
    ],
    "full": [
      "gener",
      "febrer",
      "març",
      "abril",
      "maig",
      "juny",
      "juliol",
      "agost",
      "setembre",
      "octubre",
      "novembre",
      "desembre"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d/%m/%y",
  "time24": "%T",
  "dateTime": "%a %d %b %Y %T %Z",
  "time12": "",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

